import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1b339170"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b339170')) {
      api.createRecord('1b339170', component.options)
    } else {
      api.reload('1b339170', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=1b339170", function () {
      api.rerender('1b339170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/notification/Notifications.vue"
export default component.exports